/**
 * @module CartButton
 * @description
 */
import { useContext } from "react";
import { FuelContext } from "@/providers/fuel-provider";
import Link from "next/link";
import { trackEvent } from "@/js/helpers/tracking";
import { addPageAction } from "@/js/utils/new-relic";
import styles from "./DynamicButton.module.css";

/**
 * @function CartButton
 * @description
 */
export const CartButton = ({ ...props }) => {
  const { clickThrough, outageForm } = useContext(FuelContext);
  const { href = clickThrough, position, title } = props;

  /**
   * @function handleClick
   * @description
   */
  const handleClick = (event) => {
    addPageAction("cartEntrance", { method: "CTA" });

    const data = {
      elementType: "BUTTON",
      position,
      text: title || "Check Availability",
      actionOutcome: "INTERNALLINK",
    };

    trackEvent({ action: "elementClicked", data, event });
  };

  return outageForm ? null : (
    <Link
      href={href}
      onClick={handleClick}
      data-type="cart"
      className={`btn ${styles.component__btn}`}
      {...props}
    >
      {title || "Check Availability"}
    </Link>
  );
};

export default CartButton;
